import { type I18nLocale } from '#/i18n/types/I18nLocale';

/**
 * Get month name with first letter capitalized
 *
 * @example
 *
 * Given month 4 (April)
 *
 * //=> EN
 * April
 *
 * //=> ES
 * Abril
 *
 * //=> PT
 * Abril
 */
export function getMonthName(
  isoMonth: number,
  { locale, format }: { locale: I18nLocale; format: 'short' | 'long' },
) {
  const date = new Date(
    2000,
    // Date's month is 0-indexed
    isoMonth - 1,
    // Pick a date in the middle of the month just to be sure we won't have any
    // problems with timezone shifting to the previous month
    15,
  );

  const rawMonthName = new Intl.DateTimeFormat(locale, {
    month: format,
  }).format(date);

  return rawMonthName[0].toUpperCase() + rawMonthName.toLowerCase().slice(1);
}
